import React, { useEffect, useState } from 'react'

import { Button, Popup, Label } from 'semantic-ui-react'
import { AllowPermission } from 'shared/components/AllowPermission'
import UpgradePlanModalContainer from 'components/UpgradePlanModal/container'
import constants from 'config/constants'

/**
 *
 * @param {object} props
 * @param {string | React.ReactElement} [props.label]
 * @param {string | React.ReactElement} props.title
 * @param {string | React.ReactElement} props.content
 * @param {string} props.learnMoreLink,
 * @param {boolean} props.shouldShowBillingPageLink,
 */
export default function ProFeatureLabel({
  label,
  title,
  content,
  learnMoreLink,
  shouldShowBillingPageLink,
}) {
  const [isShowBadge, setIsShowBadge] = useState(false)
  const [isPopupOpen, setIsPopupOpen] = useState(false)
  const [isUpgradeModalOpen, setIsUpgradeModalOpen] = useState(false)

  useEffect(() => {
    setIsShowBadge(shouldShowBillingPageLink)
  }, [shouldShowBillingPageLink])

  function openUpgradeModal() {
    setIsPopupOpen(false)
    setIsUpgradeModalOpen(true)
  }

  return (
    <label className="cursor-pointer">
      {label}
      <Popup
        basic
        hoverable
        open={isPopupOpen}
        onOpen={() => setIsPopupOpen(true)}
        onClose={() => setIsPopupOpen(false)}
        trigger={
          isShowBadge && (
            <span>
              <CrownBadge />
            </span>
          )
        }
        content={
          <React.Fragment>
            <h3 className="ui dividing header" style={{ paddingBottom: '10px', paddingTop: '4px' }}>
              {title}
              {isShowBadge && <CrownBadge />}
            </h3>
            <p>{content}</p>
            <a
              className="ui primary button mr3"
              href={learnMoreLink}
              target="_blank"
              rel="noreferrer"
              onClick={preventEventPropagation}
            >
              <i className="book far icon" />
              Learn more
            </a>
            {shouldShowBillingPageLink && (
              <AllowPermission permission={constants.permissions.manageBillingInformation}>
                <Button onClick={openUpgradeModal}>Upgrade plan</Button>
              </AllowPermission>
            )}
          </React.Fragment>
        }
        className="wide"
        style={{ minWidth: 380 }}
      />
      <UpgradePlanModalContainer
        isOpen={isUpgradeModalOpen}
        onClose={() => setIsUpgradeModalOpen(false)}
      />
    </label>
  )
}

export const CrownBadge = () => {
  return (
    <Label color="purple">
      <i className="fas fa-crown" />
    </Label>
  )
}

function preventEventPropagation(e) {
  e.stopPropagation()
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/ProFeatureLabel/index.js